import React, { useState } from 'react';
import { Divider, Paper, Dialog, DialogContent, DialogActions } from "@material-ui/core";
import QR from "../raw_files/qe.png";
import Bus from "../raw_files/bus.gif";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import BeenhereSharpIcon from "@material-ui/icons/BeenhereSharp";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as account from "../../_redux/accountRedux";
import { sendRefund } from "../../_redux/accountCrud";
import { Grid } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import moment from "moment-jalaali";
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/styles';
import CreditCardOutlinedIcon from '@material-ui/icons/CreditCardOutlined';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import QRCode from "react-qr-code";







export function TravelItem(props) {


    const useStyles = theme => ({
        paper: { minWidth: "500px" },
    });



    let { state } = useSelector(
        (state) => ({
            state: state.account
        }),
        shallowEqual
    );
    const { user } = useSelector(state => state.auth);

    const handleRefund = () => {
        const data = {
            status: 0,
            subject: sbj,
            description: txt,
            travelTicketId: props.data.id,
        }
        sendRefund(user, data).then(res => {
            switch (res.data.status) {
                case 200:
                    props.sendMessage('درخواست با موفقیت ارسال شد', 'success')
                    break;
                case 402:
                    props.sendMessage('برای این بلیط درخواست استرداد ثبت شده است', 'warning')
                    break;

                default:
                    props.sendMessage('ارسال نا موفق', 'danger')
                    break;
            }

        })

        setOpen(false)

    };

    const [open, setOpen] = useState(false);
    const [txt, setTxt] = useState("");
    const [sbj, setSbj] = useState("");



    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setTxt(e.target.value);
    };

    const handleSubject = (e) => {
        setSbj(e.target.value);
    };


    console.log("!!!!", props)


    let dep_time = moment(props.data.departureDatetime, 'YYYY-M-D HH:mm:ss').format('jD jMMMM jYYYY ساعت HH:mm');
    return (
        <>
            {/* <Paper>
                <div>
                    <h4 className={'p-3 d-flex'} style={{
                        justifyContent: 'space-between'
                    }}>
                        <span>
                            <LocationOnIcon className={'mr-3'} style={{
                                fill: '#4CAF50'
                            }} />
                            {props.data.sourceTownship}
                        </span>
                        <span>
                            <BeenhereSharpIcon className={'mr-3'} style={{
                                fill: '#e91e63'
                            }} />
                            {props.data.destTownship}
                        </span>
                        <span>
                            <CardMembershipIcon className={'mr-3'} style={{
                                fill: '#03A9F4'
                            }} />
                            شماره بلیط :
                            <span> {props.data.id} </span>
                        </span>
                    </h4>
                    <Divider />
                    <Grid container>
                        <Grid item sm={6}>
                            <h5 className={'p-3'}>
                                <PersonIcon />
                                <span>تاریخ و زمان حرکت:</span>
                                <span className={'ml-3'}><b>{dep_time}</b></span>
                            </h5>
                            <h5 className={'p-3'}>
                                <PersonIcon />
                                <span>هزینه:</span>
                                <span className={'ml-3'}><b>{props.data.ticketPrice}</b></span>
                            </h5>
                        </Grid>
                        <Grid item sm={6}>
                            <h5 className={'p-3'}>
                                <PersonIcon />
                                <span>تعداد صندلی:</span>
                                <span className={'ml-3'}><b>{props.data.seatCount}</b></span>
                            </h5>
                            {new Date(props.data.departureDatetime) > Date.now() ? <button className={'p-3 btn btn-primary ml-3 '} onClick={handleClickOpen}>
                                استرداد بلیط
                            </button> : null}
                        </Grid>
                    </Grid>
                </div>
            </Paper> */}
            <Paper elevation={0} className={'mt-5'} style={{ border: props.border }} >
                <div className={'row col-sm-12'}>
                    <div className='col-sm-9 pl-0 pr-0 columns-info'>
                        <div className="p-5">
                            <div>
                                <h4 className={'p-3 d-flex'} style={{
                                    justifyContent: 'space-between',
                                    borderBottom: "1px dashed #d9d9d9"
                                }}>
                                    <span>
                                        <LocationOnIcon className={'mr-3'} style={{
                                            fill: '#4CAF50'
                                        }} />
                                        {props.data.sourceTownship}
                                    </span>
                                    <span>
                                        <BeenhereSharpIcon className={'mr-3'} style={{
                                            fill: '#e91e63'
                                        }} />
                                        {props.data.destTownship}
                                    </span>
                                    <span>
                                        <CardMembershipIcon className={'mr-3'} style={{
                                            fill: '#03A9F4'
                                        }} />
                                        شماره بلیط :
                                        <span>{props.data.id}</span>
                                    </span>
                                </h4>
                                <Grid container>
                                    <Grid item sm={6}>
                                        <h5 className={'p-3'}>
                                            <PersonIcon />
                                            <span>نام:</span>
                                            <span className={'ml-3'}><b>
                                                {user.firstName + " " + user.lastName}
                                                {/* TODO */}
                                                {/* {props.data.userFirstName} 
                                            {props.data.userLastName} */}
                                            </b></span>
                                        </h5>
                                        <h5 className={'p-3'}>
                                            <PersonIcon />
                                            <span>کد ملی:</span>
                                            <span className={'ml-3'}><b>
                                                {user.nationalCode}
                                                {/* TODO */}
                                                {/* {props.data.userNationalCode} */}
                                            </b></span>
                                        </h5>
                                        <h5 className={'p-3'}>
                                            <PersonOutlineOutlinedIcon />
                                            <span>تعداد صندلی :</span>
                                            <span className={'ml-3'}><b>{props.data.seatCount}</b></span>
                                        </h5>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <h5 className={'p-3'}>
                                            <AccessTimeOutlinedIcon />
                                            <span>تاریخ و زمان حرکت:</span>
                                            <span className={'ml-3'}><b>{dep_time}</b></span>
                                        </h5>
                                        <h5 className={'p-3'}>
                                            <CreditCardOutlinedIcon />
                                            <span>هزینه:</span>
                                            <span className={'ml-3'}><b>
                                                {props.data.ticketPrice.toLocaleString('ar-EG')} <span>ریال</span>
                                            </b>
                                            </span>
                                        </h5>
                                        {new Date(props.data.departureDatetime) > Date.now() ? <button className={'p-3 btn btn-primary ml-3 '} onClick={handleClickOpen}>
                                            استرداد بلیط
                                        </button> : null}
                                        {/*<h5 className={'p-3'}>*/}
                                        {/*    <PersonIcon/>*/}
                                        {/*    <span>شماره صندلی:</span>*/}
                                        {/*    <span className={'ml-3'}><b>{props.data.seatNumber}</b></span>*/}
                                        {/*</h5>*/}
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                        <div className="hr dashed"></div>
                    </div>
                    <div className='col-sm-3 p-5 text-center'>
                        {/* {/ <img src={`data:image/jpeg;base64,${data.qrcode}`} style={{width:'80%'}}/> /} */}
                        <QRCode value={props.data.qrCode} />
                    </div>
                    {/* <PrintItem/> */}
                </div>
                {/* <PrintItem/> */}
            </Paper>
            <div >
                <Dialog fullWidth={true} onClose={handleClose} open={open} >
                    <DialogContent dividers>
                        <div className="form-group align-items-end">
                            <label for="recipient-name" class="col-form-label">عنوان</label>
                            <input type="text" class="form-control" id="recipient-name" value={sbj} onChange={handleSubject} />
                            <div>
                                <label for="message-text" className="col-form-label">توضیحات</label>
                                <textarea className="form-control" id="message-text" value={txt} onChange={handleChange}></textarea>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <button style={{ width: "v6w" }} className="btn btn-danger mr-4" onClick={handleClose}>
                            انصراف
                        </button>

                        <button style={{ width: "10vw" }} className="btn btn-primary mr-4" onClick={() => handleRefund()}>
                            ارسال استرداد بلیط
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        </>


    )
}

export default injectIntl(connect(null, account.actions)(TravelItem));